var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProtectIcon = function SvgProtectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    color: "#FFF",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.72 5.492-7.333-2.747c-.76-.28-2-.28-2.76 0L7.293 5.492c-1.413.533-2.56 2.186-2.56 3.693v10.8c0 1.08.707 2.507 1.574 3.147l7.333 5.48c1.293.973 3.413.973 4.707 0l7.333-5.48c.867-.654 1.573-2.067 1.573-3.147v-10.8c.014-1.507-1.133-3.16-2.533-3.693Zm-4.08 7.467-5.733 5.733c-.2.2-.454.293-.707.293a.989.989 0 0 1-.707-.293l-2.133-2.16a1.006 1.006 0 0 1 0-1.414 1.006 1.006 0 0 1 1.413 0l1.44 1.44 5.027-5.026a1.006 1.006 0 0 1 1.413 0 1.01 1.01 0 0 1-.013 1.427Z",
    fill: "currentColor"
  })));
};
export default SvgProtectIcon;